module.exports = __webpack_public_path__ + "img/main_logo.efb463d7.png";